import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const HeartFilled = (props: SvgProps) => (
  <Svg viewBox='0 0 14 13' {...props}>
    <Path
      d='M12.075 1.972a3.152 3.152 0 0 0-1.025-.72 3.025 3.025 0 0 0-2.417 0 3.152 3.152 0 0 0-1.025.72L7 2.612l-.609-.64a3.153 3.153 0 0 0-1.024-.719 3.026 3.026 0 0 0-2.417 0 3.153 3.153 0 0 0-1.025.72 3.335 3.335 0 0 0-.685 1.076 3.467 3.467 0 0 0 0 2.54c.16.403.392.77.685 1.077l.609.64L7 12l4.466-4.694.609-.64c.293-.308.526-.674.684-1.076a3.465 3.465 0 0 0 0-2.54 3.336 3.336 0 0 0-.684-1.078Z'
      fill='currentColor'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
